module.exports = __webpack_public_path__ + "fonts/overpass-heavy.00989a5e.otf";